import React, { useEffect, useLayoutEffect } from "react";
import TextContainer from "../../components/text/TextContainer";
import PageTitle from "../../components/titles/PageTitle";
import Modal from "../../components/modal/Modal";
import MainContainer from "../../components/container/MainContainer";
import { ChevronLeft, Save, Trash2 } from "lucide-react";
import { Link, useLocation, useParams } from "react-router-dom";
import Loading from "../../components/loading/Loading";
import { useDispatch, useSelector } from "react-redux";
import { useAuthorization } from "../../hooks/useAuthorization";
import AddCurrency from "./AddCurrency";
import DeleteCurrency from "./DeleteCurrency";
import { openModal } from "../../features/modalSLice";
import {
  getCurrency,
  unsetSelectedCurrency,
} from "../../features/currenciesSlice";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";

const SingleCurrency = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthorized } = useAuthorization();
  const modalContent = useSelector((state) => state.modal.content);
  const currency = useSelector((state) => state.currencies.selected);
  const loading = useSelector((state) => state.currencies.load.getCurrency);

  const openEditCurrencyModal = (edit, id) => {
    dispatch(openModal(<AddCurrency edit={edit} id={id} />));
  };

  const openDeleteCurrencyModal = (id) => {
    dispatch(openModal(<DeleteCurrency id={id} />));
  };

  useLayoutEffect(() => {
    dispatch(getCurrency(id));

    return () => {
      dispatch(unsetSelectedCurrency());
    };
  }, []);

  if (loading === loadStatus.loading) {
    return <Loading />;
  }

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      <Modal>{modalContent}</Modal>
      <PageTitle title={"Currency - " + currency.name} />
      <div className="bg-content  border border-bkg2 rounded-md p-7 mb-5 !text-text-1/55">
        <TextContainer label="Name" content={currency.name} />
        <TextContainer label="Code" content={currency.code} />
        <TextContainer label="Symbol" content={currency.symbol} />
        <TextContainer label="Country" content={currency.country} />
      </div>
      <div className="p-4 border border-bkg2 rounded-md flex justify-between items-center">
        <Link to="/settings/currencies" className="cancel-rss-btn">
          <ChevronLeft size={18} /> Back
        </Link>
        <div className="flex gap-3">
          <button
            onClick={(e) => openEditCurrencyModal(true, id)}
            disabled={!isAuthorized("settings", "update")}
            className="add-rss-btn"
          >
            <Save size={18} />
            Edit
          </button>
          <button
            onClick={(e) => openDeleteCurrencyModal(id)}
            disabled={!isAuthorized("settings", "delete")}
            className="delete-rss-btn"
          >
            <Trash2 size={18} />
            Delete
          </button>
        </div>
      </div>
    </MainContainer>
  );
};

export default SingleCurrency;
